<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { BaseSkeleton } from '@/shared/ui/BaseSkeleton';
import { CardSeparator } from '@/shared/ui/CardSeparator';
import { FlowCard } from '@/shared/ui/FlowCard';

interface Props {
  isMainLoader: boolean;
}

defineProps<Props>();

const { t } = useI18n();

const text = ref('');

const delay = () => new Promise(resolve => setTimeout(resolve, 5000));

onMounted(async () => {
  text.value = t('renew.renew_policy_page.preloader.text.1');
  await delay();
  text.value = t('renew.renew_policy_page.preloader.text.2');
  await delay();
  text.value = t('renew.renew_policy_page.preloader.text.3');
});
</script>

<template>
  <FlowCard class="skeleton" controls-off>
    <p v-if="isMainLoader" class="skeleton__text">
      {{ text }}
    </p>
    <div class="skeleton__header">
      <BaseSkeleton :width="320" :height="173" />
    </div>
    <div class="skeleton__number">
      <BaseSkeleton :width="150" :height="40" />
    </div>
    <CardSeparator />
    <div class="skeleton__info">
      <BaseSkeleton fullwidth :height="112" />
    </div>
    <div class="skeleton__policyholder">
      <BaseSkeleton fullwidth :height="240" />
    </div>
  </FlowCard>
</template>

<style lang="scss" scoped>
@use 'RenewalSkeleton';
</style>
